export function prepareValues(market: string, productId: number[]): { marketName: string; commaSeparatedIds: string } {
  if (!market || !productId) return null
  const parts = market.split('_')
  const marketName = parts[0]
  const commaSeparatedIds = productId.toString()
  return { marketName, commaSeparatedIds }
}
